import React from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router"
import { compose } from "ramda"
import { parse } from "qs"
import { Modal } from "partials/Modal"
import { CardTop, CardBottom, CardBottomFooter } from "partials/Card"
import { BoundComponent } from "utils/react"
import { StringInput } from "modules/inputs/StringInput"
import Api from "modules/domain/api"
import Core from "app/core/state"
import State from "app/main/state"
import { Anchor } from "partials/Anchor"

const { Form, Field, SubmitButton } = State.loginVendorForm.components

const enhance = compose(
  withRouter,
  connect(
    state => ({
      initialStoreSlug: State.loginVendorForm.select.values(state).initialStoreSlug,
      email: State.loginVendorForm.select.values(state).email,
      passwordIsSet: State.loginVendorForm.select.values(state).passwordIsSet,
    }),
    {
      sendPasswordReset: () => Api.user.post("reset_pin"),
      loginVendor: Core.loginVendor,
      requestVendorPasswordReset: State.actions.requestVendorPasswordReset,
    },
  ),
)

export default enhance(
  class LoginVendor extends BoundComponent {
    state = {
      passwordResetSent: false,
    }
    componentDidMount() {
      const {
        location: { search },
      } = this.props
      const { key, storeSlug, email } = parse(search.slice(1))

      if (key) {
        this.props.loginVendor({ oneTimePassword: key, storeSlug, email })
      }
    }
    async sendPasswordReset() {
      this.setState({ passwordResetSent: true })

      await this.props.sendPasswordReset()
    }
    render() {
      const { email, passwordIsSet, requestVendorPasswordReset } = this.props

      return (
        <Modal isOpen size="xl">
          <Form>
            <CardTop>
              <h1>Vendor Login</h1>
            </CardTop>
            <CardBottom>
              <div className="flex flex-col gap-2">
                {!passwordIsSet && <p>Enter the password we sent to {email}.</p>}
                <Field
                  name={passwordIsSet ? "password" : "oneTimePassword"}
                  Input={StringInput}
                  inputProps={{ className: "w-full" }}
                  placeholder={passwordIsSet ? "Password" : "One time password"}
                  type="password"
                />
                {passwordIsSet ? (
                  <small className="block text-right">
                    <Anchor onClick={requestVendorPasswordReset}>Forgot password?</Anchor>
                  </small>
                ) : null}
              </div>
              <CardBottomFooter>
                <SubmitButton>Login</SubmitButton>
              </CardBottomFooter>
            </CardBottom>
          </Form>
        </Modal>
      )
    }
  },
)
